module.exports = __webpack_public_path__ + "static/img/propile-top-background.2f4b1630.svg";